// Export everything
import Router from './router';

export { Resource, Response, GenericResource } from './generic';

export { BaseResourceError, InvalidResponseCode, RequestValidationError, NetworkError } from './errors';

export { ValidationError, SingleValidationError, ListValidationError, ValidationErrorInterface, ParentValidationErrorInterface, parseErrors, prepareError } from './validationError';

export default Router;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/index.js
// module id = 525
// module chunks = 0